import { render, staticRenderFns } from "./_gspayewallet.vue?vue&type=template&id=2a9a07c8&lang=pug&"
import script from "./_gspayewallet.vue?vue&type=script&lang=js&"
export * from "./_gspayewallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports